<template>
  <div class="login">
    <div class="vs_bg">
      <a-form @submit.prevent="doLogin" :form="form">
      <!-- <a-tabs size="large" :tabBarStyle="{textAlign: 'center'}" style="padding: 0 2px;" :activeKey="activeKey"
              @change="handleTabsChange">
        <a-tab-pane tab="" key="1">
          <a-alert type="error" :closable="true" v-show="error" :message="error" showIcon
                   style="margin-bottom: 24px;"></a-alert>
          <a-form-item>
            <a-input size="large"  v-decorator="['name',{rules: [{ required: true, message: '请输入账户名', whitespace: true}]}]">
              <a-icon slot="prefix" type="user"></a-icon>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input size="large" type="password" v-decorator="['password',{rules: [{ required: true, message: '请输入密码', whitespace: true}]}]">
              <a-icon slot="prefix" type="lock"></a-icon>
            </a-input>
          </a-form-item>
        </a-tab-pane>

      </a-tabs> -->
      <a-form-item class="ju_mb30">
        <a-input
          size="large"
          :placeholder="$t('login.username')"
          v-decorator="['name',{rules: [{ required: true, message: $t('login.inputUsername'), whitespace: true}]}]"
        >
          <a-icon slot="prefix" type="user"></a-icon>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          size="large"
          :placeholder="$t('login.password')"
          type="password"
          v-decorator="['password',{rules: [{ required: true, message: $t('login.inputPassword'), whitespace: true}]}]"
        >
          <a-icon slot="prefix" type="lock"></a-icon>
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-button :loading="loading" style="" class="ju_btn" size="large" htmlType="submit" type="primary">
          {{ $t('login.login') }}
        </a-button>
      </a-form-item>
      <div class="forgot-row">
        <a @click="openForgot">{{ $t('forgotPwd.forgot') }}</a>
      </div>
<!--      <div>-->
<!--        <a style="float: right" @click="regist">注册账户</a>-->
<!--      </div>-->
    </a-form>
    </div>
    <forgot-password
      :visible="forgotVisible"
      :username="forgotUsername"
      @close="forgotVisible = false"
      @success="onForgotSuccess"
    ></forgot-password>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import ForgotPassword from './ForgotPassword'

export default {
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  name: 'Login',
  components: {ForgotPassword},
  data () {
    return {
      loading: false,
      error: '',
      activeKey: '1',
      dicts: [],
      forgotVisible: false,
      forgotUsername: ''
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  // created () {
  //   this.$db.clear()
  //   this.$router.options.routes = []
  // },
  methods: {
    openForgot () {
      this.forgotUsername = this.form.getFieldValue('name') || ''
      this.forgotVisible = true
    },
    onForgotSuccess () {
      this.forgotVisible = false
    },
    doLogin () {
      //if (this.activeKey === '1') {
        // 用户名密码登录
        this.form.validateFields(['name', 'password'], (errors, values) => {
          if (!errors) {
            this.loading = true
            let name = this.form.getFieldValue('name')
            let password = this.form.getFieldValue('password')
            let password2= this.$aesEncrypt.encrypt(password)
            //console.log("********")
            //console.log(password2)
            this.$post('login', {
              username: name,
              password: this.$aesEncrypt.encrypt(password)
            }).then((r) => {
              let data = r.data.data
              this.saveLoginData(data)
              setTimeout(() => {
                this.loading = false
              }, 500)
              this.getDicts()
              this.$router.push('/')
            }).catch((e) => {
              console.error(e)
              setTimeout(() => {
                this.loading = false
              }, 500)
            })
          }
        })
      //}
      //if (this.activeKey === '2') {
        // 手机验证码登录
        //this.$message.warning('暂未开发')
      //}
    },
    regist () {
      this.$emit('regist', 'Regist')
    },
    getCaptcha () {
      this.$message.warning('暂未开发')
    },
    handleTabsChange (val) {
      this.activeKey = val
    },
    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor',
      setCurrency: 'setting/setCurrency',
      setDicts: 'dict/setDicts',
      setCompany:'account/setCompany'
    }),
    saveLoginData (data) {
      // 清除相纸不足提醒的“已提醒”标记，保证本次登录后首次打开首页重新弹窗提醒
      sessionStorage.removeItem('LOW_PAPER_NOTIFIED')
      this.setToken(data.token)
      this.setExpireTime(data.exipreTime)
      this.setUser(data.user)
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)
      this.setTheme(data.config.theme)
      this.setLayout(data.config.layout)
      this.setMultipage(data.config.multiPage === '1')
      this.fixSiderbar(data.config.fixSiderbar === '1')
      this.fixHeader(data.config.fixHeader === '1')
      this.setColor(data.config.color)
      this.setCurrency(data.config.currency || '¥')
      this.setCompany(data.company)
    },
    getDicts () {
      this.$get('dict/trim').then((r) => {
        let data = r.data
        this.saveDictData(data)
      }).catch((e) => {
        console.error(e)
      })
    },
    saveDictData (data) {
      this.setDicts(data)
    }
  }
}
</script>

<style lang="less" scoped>
  .login {
    position: relative;
    .icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }
    .vs_bg{background-color: #fff;position: relative;z-index: 100;
    padding-top:60px;
    padding-left: 60px;
    padding-right: 60px;
    padding-bottom:60px ;border-top-left-radius:20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px ;
    box-shadow: 0px 20px 29px 0px rgba(37, 24, 89, 0.65);
    }
    .jp_title{font-size: 36px;color: #9058F9;padding-top: 33px;padding-bottom: 30px;}
    /deep/ .ant-btn-primary{background-color: #D240DF;border-color: #D240DF;}
  }
  .ant-form-item{margin-bottom: 0px!important;}
  .ant-form-item{margin-bottom: 0px;}
  .ju_mb30{margin-bottom: 30px!important;}
  .ju_btn{width: 100%; margin-top: 46px;height: 56px;font-size: 24px;border-radius: 15px;}
  .forgot-row{text-align: right; margin-top: 18px;}
  .forgot-row a{color: #9058F9; font-size: 15px;}
  /deep/.ant-input-lg{height: 45px;line-height: 45px;border-radius: 6px;}
  .ant-input-affix-wrapper .ant-input{border-radius: 6px;}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue